import { api } from "@/helpers/api_helper";
import { ApiHelper } from "@altimateai/ui-components/teammate";
import { useState, useEffect } from "react";

// @deprecated: This hook is deprecated and will be removed in future releases.
const useComponentsHelper = () => {
  const [isComponentsApiInitialized, setIsComponentsApiInitialized] = useState(false);

  useEffect(() => {
    console.info("updating components api helper");
    // This overrides the components library api methods
    // @ts-expect-error: ApiHelper.get signature is intentionally overridden for legacy compatibility
    ApiHelper.get = async (url: string, data: unknown) => {
      return (
        // @ts-expect-error: legacy bridge calls api.get without zodSchema
        api.get(url, data)
      );
    };
    // @ts-expect-error: ApiHelper.post signature is intentionally overridden for legacy compatibility
    ApiHelper.post = async (url: string, data: unknown, request: RequestInit = {}) => {
      // TODO updat api helper to handle other request methods
      if (request.method === "DELETE") {
        return (
          // @ts-expect-error: legacy bridge calls api.delete without zodSchema
          api.delete(url, data)
        );
      }
      if (request.method === "PUT") {
        return (
          // @ts-expect-error: legacy bridge calls api.update without zodSchema
          api.update(url, data)
        );
      }
      return (
        // @ts-expect-error: legacy bridge calls api.post without zodSchema
        api.post(url, data)
      );
    };
    setIsComponentsApiInitialized(true);
  }, []);

  return {
    isComponentsApiInitialized,
  };
};

export default useComponentsHelper;
